import type { FC } from 'react';

import type { FormFieldProps } from '../FormField';
import FormSelect from '../FormSelect';
import { volumeUnitOptions } from './helpers';
import type { VolumeUnit } from './types';

interface Props extends FormFieldProps {
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormVolumeUnitSelect: FC<Props> = (props) => (
  <FormSelect<VolumeUnit> {...props} isSearchable={false} options={volumeUnitOptions} />
);

export type { Props as FormVolumeUnitSelectProps };
export default FormVolumeUnitSelect;
